import { Sparkles, useAspect, useTexture} from "@react-three/drei";
import { useState, useEffect} from 'react'
import * as THREE from 'three'
import { EffectComposer, Bloom } from '@react-three/postprocessing'
import { MeshReflectorMaterial } from "@react-three/drei"

function Ground(props) {
  const [floor, normal] = useTexture(['./surface.jpg', './surface_normal.jpg'])
  return (
    <mesh rotation={[-Math.PI / 2, 0, 0]} position-y={-1} position-z={-1} >
      <planeGeometry args={[12, 12]} />
      <MeshReflectorMaterial resolution={1024} args={[8.8, 8.8]} {...props} color="#f0f0f0" metalness={0} roughnessMap={floor} normalMap={normal} normalScale={[2, 2]} {...props} />
    </mesh>
  )
}

function Video() {
  const scale = useAspect(1920, 1080, 1.5)
  // Video texture by: https://www.pexels.com/video/abstract-video-4990242/
  const [video] = useState(() =>
    Object.assign(document.createElement('video'), { src: './video.mp4', crossOrigin: 'anonymous', loop: true, muted: true, playsinline:true})
  )
  video.setAttribute('playsinline',true)

  useEffect(() => video.play(), [video])
  return (
    <mesh scale={scale} position-z={-5} position-y={1} >
      <planeGeometry />
      <meshBasicMaterial toneMapped={true} side={THREE.DoubleSide}>
        <videoTexture attach="map" args={[video]} encoding={THREE.sRGBEncoding} />
      </meshBasicMaterial>
    </mesh>
  )
}

function Video2() {
  const scale = useAspect(1920, 1080, 1.5)
  // Video texture by: https://www.pexels.com/video/abstract-video-4990242/
  const [video] = useState(() =>
    Object.assign(document.createElement('video'), { src: './video.mp4', crossOrigin: 'anonymous', loop: true, muted: true, playsinline:true})
  )
  video.setAttribute('playsinline',true)

  useEffect(() => void video.play(), [video])
  return (
    <mesh scale={scale} position={[4, 1, -1]} rotation-y={-1.6} >
      <planeGeometry />
      <meshBasicMaterial toneMapped={true} side={THREE.DoubleSide}>
        <videoTexture attach="map" args={[video]} encoding={THREE.sRGBEncoding} />
      </meshBasicMaterial>
    </mesh>
  )
}

//Warning: while testing I noticed that particles cause problems with the occlude attribute of html components
// function Particles(){

//   return (
//     <Sparkles opacity={50} count={400} scale={[20, 20, 10]} size={1.5} speed={2} />
//   )

// }

// function Glow(){
//   return (
//     <EffectComposer multisampling={4}>
//       <Bloom 
//         mipmapBlur
//         intensity={0.5}
//         luminanceThreshold={ 0 }
//       />
//     </EffectComposer>
//   )
// }

export { Ground, Video, Video2 }



